export default __webpack_public_path__ + "media/images/icon-uncensored-news-white-951f61984123a829526a5071065dfa57.png";